<ng-container *ngIf="vm$ | async as vm">
  <form name="frmNotitie" (ngSubmit)="saveSubj.next(vm)">
    <div class="header-row">
      <h1 class="head1">Nieuwe notitie toevoegen</h1>
      <i role="button" aria-label="Annuleer notitie toevoegen" title="Annuleer" class="icon-disagree c2-clickable" (click)="cancel()"></i>
    </div>

    <div class="input-row">
      <textarea [(ngModel)]="vm.notitie.NotitieContent" name="notitie.NotitieContent" rows="4"></textarea>
    </div>

    <div class="ontvangers-row">
      <h2 class="head2">Ontvangers</h2>
    </div>

    <div class="ontvangerspanel-row">

      <div class="allen-row customcheckbox">
        <input id="notitie-allen" title="Schakelen alle personen" name="allen" type="checkbox" [ngModel]="vm.allenSelected" (ngModelChange)="toggleAllenSubj.next($event)" />
        <label for="notitie-allen" aria-labelledby="notitie-allen" >Allen</label>
      </div>

      <div class="partijen-row">
        <div *ngFor="let partij of vm.partijen trackBy:getPartijId" class="partij-col">

          <div class="partij-naam-row customcheckbox">
            <input id="partij{{partij.Id}}" name="partij{{partij.Id}}" title="Schakelen {{partij.Naam}}" type="checkbox" [ngModel]="partij.isSelected" (ngModelChange)="togglePartijSubj.next(partij)" />
            <label for="partij{{partij.Id}}" [attr.aria-labelledby]="'partij'+partij.Id" >{{partij.Naam}}</label>
          </div>

          <div class="partij-persoon-row customcheckbox" *ngFor="let persoon of partij.Leden trackBy:getLidId">
              <input id="persoon{{persoon.Id}}" name="persoon{{persoon.Id}}" title="Schakelen {{persoon.Naam}}" type="checkbox" [ngModel]="persoon.isSelected" (ngModelChange)="togglePersoonSubj.next(persoon)" />
              <label for="persoon{{persoon.Id}}" [attr.aria-labelledby]="'persoon'+persoon.Id" >{{persoon.Naam}}</label>
          </div>

        </div>
      </div>
    </div>

    <div class="buttons-row">
      <button type="button" (click)="cancel()" class="btn btn-default">Annuleer</button>
      <button type="submit" class="btn btn-primary">Bewaren</button>
    </div>
  </form>
</ng-container>